/* eslint-disable react/jsx-pascal-case */
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import SideBarButtons from "../SideBarButtons/SideBarButtons";
import {
  FranchiseLogo,
  TenantIndicator,
} from "../FranchiseBranding";

interface SideBarProps {
  isMobileOpen: boolean;
  onMobileClose: () => void;
  isMobile: boolean;
}

export default function SideBar({ isMobileOpen, onMobileClose, isMobile }: SideBarProps) {
  const reduxStore = useSelector((state: RootState) => state.user);
  const chosenRole: string = reduxStore?.currentRole;

  const SIDEBAR_ROLES = [
    "COMPANY_ADMIN",
    "PARTICULAR_CLIENT",
    "RRHH",
    "RRHH_APPOINTMENTS",
    "CANDIDATE_APPOINTMENTS",
    "RRHH_APPOINTMENTS_AND_ABSENTEE",
    "RRHH_RESULT",
    "RRHH_ABSENTEE",
    "ADM_ABSENTEE",
    "ACCOUNTANT",
    "ASESOR",
  ];

  return SIDEBAR_ROLES.includes(chosenRole) ? (
    <SideBarLayout
      isMobileOpen={isMobileOpen}
      onMobileClose={onMobileClose}
      isMobile={isMobile}
    />
  ) : (
    <></>
  );
}

interface SideBarLayoutProps {
  isMobileOpen: boolean;
  onMobileClose: () => void;
  isMobile: boolean;
}

function SideBarLayout({ isMobileOpen, onMobileClose, isMobile }: SideBarLayoutProps) {
  const { reduceSideBar } = useSelector((state: RootState) => state.app);

  const getSidebarClasses = () => {
    let classes = "sidebar-atendoo";

    if (reduceSideBar && !isMobile) {
      classes += " small-sidebar";
    }

    if (isMobile) {
      classes += " mobile-sidebar";
      if (isMobileOpen) {
        classes += " mobile-sidebar-open";
      }
    }

    return classes;
  };

  const showExpandedBranding = !reduceSideBar || isMobile;

  return (
    <div className={getSidebarClasses()}>
      <div className="sidebar-header">
        <div className="logo-container">
          <FranchiseLogo
            className="logo-image"
            compact={!showExpandedBranding}
            variant="light"
          />

          {/* Botón de cerrar para mobile */}
          {isMobile && (
            <button
              className="mobile-close-btn"
              onClick={onMobileClose}
              aria-label="Cerrar menú"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  x1="18"
                  y1="6"
                  x2="6"
                  y2="18"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <line
                  x1="6"
                  y1="6"
                  x2="18"
                  y2="18"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          )}
        </div>

        {showExpandedBranding && (
          <>
            <h6
              className="portal-title"
              style={{
                textAlign: isMobile ? "left" : "center",
                width: "100%",
              }}
            >
              Portal Clientes
            </h6>
            <div className="sidebar-tenant">
              <TenantIndicator className="tenant-indicator tenant-indicator--sidebar" />
            </div>
          </>
        )}
      </div>

      <div className="sidebar-content">
        <SideBarButtons
          onMobileItemClick={isMobile ? onMobileClose : undefined}
          compact={!showExpandedBranding}
        />
      </div>
    </div>
  );
}
